/**
 * The http(s) origin of a URL (`https://nova.example.com/path/` → `https://nova.example.com`),
 * or an empty string when the value is not a valid http(s) URL.
 */
export function toOrigin(value: unknown): string {
  if (typeof value !== 'string' || !value) return ''

  try {
    const url = new URL(value)

    return url.protocol === 'https:' || url.protocol === 'http:' ? url.origin : ''
  } catch {
    return ''
  }
}
